import { Directive, Input, TemplateRef } from "@angular/core";
import { TabGroupPanelContext } from "@app/models/tab-group-panel/tab-group-panel";

@Directive({
  selector: "[appTabContentPanelTemplate]",
})
export class TabContentPanelDirective {
  @Input() hasCustomTemplate: boolean;
  @Input() isLoadedComponent = false;

  constructor(public templateRef: TemplateRef<TabGroupPanelContext>) {}
}
